import { UntypedFormArray, UntypedFormControl } from '@angular/forms';

// summaries·sections·AI 적용 사진은 FormGroup({photo})라 patchValue하면 `file`이 조용히 버려지고,
// 미리보기 data URL이 그대로 저장돼 TEXT 컬럼에서 잘린다.

export function replacePhotoControl(photos: UntypedFormArray, index: number, value: unknown): boolean {
  if (value == null || index < 0 || index >= photos.length) return false;
  photos.setControl(index, new UntypedFormControl(value, photos.at(index).validator));
  return true;
}

export function movePhotoControl(photos: UntypedFormArray, from: number, to: number): void {
  if (from === to || from < 0 || from >= photos.length) return;
  const control = photos.at(from);
  photos.removeAt(from, { emitEvent: false });
  photos.insert(to, control);
}
